<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex filter-box my-2">
                      <div class="col-flex-2">
                        <ng-select [items]="type_list" bindLabel="name" bindValue="id" [closeOnSelect]="false" placeholder="Select Type"
                          [(ngModel)]="selected_type" [ngModelOptions]="{ standalone: true }" (change)="getTypeId($event)">
                        </ng-select>
                      </div>
                      <div class="col-flex-2">
                        <ng-select [items]="gig_tags_list" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
                          placeholder="Select Gig Keyword" [(ngModel)]="selected_gig_tag" [ngModelOptions]="{ standalone: true }"
                          (change)="getGigId($event)">
                        </ng-select>
                      </div>
                      <div class="col-flex-2">
                        <ng-select [items]="domain_list" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
                          placeholder="Select Domain" [(ngModel)]="selected_domain" [ngModelOptions]="{ standalone: true }"
                          (change)="getDomainId($event)">
                        </ng-select>
                      </div>
                      <!-- <div class="col-flex-2">
                                          <ng-select [items]="skills_keywords_List" bindLabel="displayname" bindValue="_id"
                                            [closeOnSelect]="false" placeholder="Select Skill Keywords"
                                            [(ngModel)]="selected_skills_keywords" [ngModelOptions]="{ standalone: true }"
                                            (change)="getSkillKeywordsTagsId($event)">
                                          </ng-select>
                                        </div>
                                        <div class="col-flex-2">
                                          <ng-select [items]="features_keywords_List" bindLabel="displayname" bindValue="_id"
                                            [closeOnSelect]="false" placeholder="Select features Keywords"
                                            [(ngModel)]="selected_features_keywords" [ngModelOptions]="{ standalone: true }"
                                            (change)="getFeaturesKeywordsTagsId($event)">
                                          </ng-select>
                                        </div>
                                        <div class="col-flex-2">
                                          <ng-select [items]="projects_keywords_List" bindLabel="displayname" bindValue="_id"
                                            [closeOnSelect]="false" placeholder="Select Projects Keywords"
                                            [(ngModel)]="selected_projects_keywords" [ngModelOptions]="{ standalone: true }"
                                            (change)="getProjectsKeywordsTagsId($event)">
                                          </ng-select>
                                        </div> -->
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                  <div class="row-flex search-container">
                    <div class="col-flex-2 mb-1 position-relative">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" placeholder="Search Name | Notes | Skills | Features | Projects" #name (keydown.enter)="filterAssets(searchVal,'','','')"
                        [(ngModel)]="searchVal" />
                      <button class="btn search-btn glow position-absolute"
                        (click)="filterAssets(searchVal,'','','')">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/assets/add" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Digital
                      Guideline</button>
                </div>
              </div>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                [count]="page.totalPages" [offset]="page.offset" (page)="pageChangeData($event)"></ngx-datatable>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="false" [count]="page.totalPages" [offset]="page.offset"
              (page)="pageChangeData($event)">
              <ngx-datatable-column name="Name" prop="displayname" [width]="450" [cellClass]="'leftAlign'">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center">
                    <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                      <div class="avatar-content">
                        {{ row?.name | shortName }}
                      </div>
                    </div>
                    <div class="cell-line-height cursor-pointer">
                      <p class="font-medium-1 line-height-1 mb-0" (click)="confirmUpdate(row,'view',infoModal)">
                        {{ row?.name }}
                      </p>
                      <div class="keywords-tags">
                        <span class="badge badge-pill bg-light-info my-1 mx-1" (click)="goToKeywords(row,'skill',infoModal)">Skill</span>
                        <span class="badge badge-pill bg-light-warning my-1 mx-1" (click)="goToKeywords(row,'feature',infoModal)">Features</span>
                        <span class="badge badge-pill bg-light-secondary my-1 mx-1" (click)="goToKeywords(row,'project',infoModal)">Projects</span>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Tags" prop="category">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <div *ngIf="user_role.roles=='admin' || empType.includes('Managment')">
                        <div *ngFor="let item of row.category" [matMenuTriggerFor]="menuTags">
                          <span *ngIf="item.name !=='Draft'" class="badge badge-pill bg-light-primary mx-1 my-1">{{item.name}}</span>
                          <span *ngIf="item.name ==='Draft'" class="badge badge-pill bg-light-danger mx-1 my-1">{{item.name}}</span>
                          <mat-menu #menuTags="matMenu" id="menuTags">
                            <div *ngFor="let tags of gig_tags_list">
                              <button mat-menu-item *ngIf="tags?.name !== item?.name" (click)="updateTags(row._id,tags._id)">
                                <span *ngIf="tags?.name !== item?.name"
                                  class="badge badge-pill bg-light-primary mx-1 my-1">{{tags.name | titlecase}}</span>
                              </button>
                            </div>
                          </mat-menu>
                        </div>
                      </div>
                      <div  *ngIf="empType.includes('Sales') && !empType.includes('Managment')">
                        <div *ngFor="let item of row.category">
                          <span class="badge badge-pill text-capitalize bg-light-primary mx-1 my-1">{{item.name}}</span>
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
              <ngx-datatable-column name="Type" prop="type">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div *ngIf="user_role.roles=='admin' || empType.includes('Managment')">
                    <div class="cell-line-height" [matMenuTriggerFor]="menuType">
                      <b>{{ row?.type | uppercase}}</b>
                      <mat-menu #menuType="matMenu" id="menuType">
                        <div *ngFor="let type of type_list">
                          <button mat-menu-item *ngIf="type?.id !== row?.type" (click)="updateType(row._id,type.id)">
                            <span *ngIf="type?.id !== row?.type">{{type.name}}</span>
                          </button>
                        </div>
                      </mat-menu>
                    </div>
                  </div>
                  <div *ngIf="empType.includes('Sales') && !empType.includes('Managment')">
                    <b>{{ row?.type | titlecase}}</b>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Domain" prop="domain">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div *ngIf="user_role.roles=='admin' || empType.includes('Managment')">
                    <div *ngFor="let item of row.domain" [matMenuTriggerFor]="menuDomain">
                      <span >{{item.displayname}}</span>
                      <mat-menu #menuDomain="matMenu" id="menuDomain">
                        <div *ngFor="let tags of domain_list">
                          <button mat-menu-item *ngIf="tags?.name !== item?.name" (click)="updateDomain(row._id,tags._id)">
                            <span *ngIf="tags?.name !== item?.name">{{tags.displayname}}</span>
                          </button>
                        </div>
                      </mat-menu>
                    </div>
                  </div>
                  <div *ngIf="empType.includes('Sales') && !empType.includes('Managment')">
                    <div *ngFor="let item of row.domain">
                      <span>{{item.displayname}}</span>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
             
              <ngx-datatable-column name="Modified By" prop="lastmodified_by">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="cell-line-height">
                    {{ row?.lastmodified_by[0].name }} <br>
                    {{ row?.updated_at | date:'mediumDate' }}
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Actions">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <i  mat-button [matMenuTriggerFor]="menu" *ngIf="user_role.roles=='admin' || empType.includes('Managment')"
                    class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                    <mat-menu #menu="matMenu">
                      <!-- <i   class="ft-edit text-primary cursor-pointer mr-2" (click)="confirmUpdate(row._id,'update')"></i>
                      <i  class="ft-trash-2 cursor-pointer danger"
                        (click)="ConfirmColor(row._id)"></i> -->
                        
                      <button *ngIf="user_role.roles=='admin' || empType.includes('Managment')"  mat-menu-item (click)="confirmUpdate(row._id,'update')"><span><i   class="ft-edit text-primary cursor-pointer mx-1" ></i></span>Edit</button> 
                      <button *ngIf="user_role.roles =='admin'"  mat-menu-item (click)="ConfirmColor(row._id)"><span><i  class="ft-trash-2 cursor-pointer danger mx-1"
                        ></i></span>Delete</button> 
                      <button  mat-menu-item (click)="openModal(myModalNotesAdminNotes,row)"> <span><i class="ft-settings text-primary cursor-pointer mx-1"	></i></span> View Notes </button> 

                    </mat-menu>
                 
                  <i class="ft-copy primary cursor-pointer mx-1" (click)="copyItem(row._id)"></i>
                </ng-template>
              </ngx-datatable-column> 
            </ngx-datatable>
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div> 
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

<!------------- Info Popup --------------------------------------->
<div>
  <ng-template #infoModal>
    <div class="modal-header">
      <div class="d-flex align-items-center">
        <!-- Display the type with a custom chip -->
        <span *ngIf="current_data?.type" class="type-chip bg-light-info mr-1">
          Type:<span class="bg-light-primary badge badge-pill m-1 text-uppercase">{{ current_data?.type | titlecase }}</span> 
        </span>
      
        <!-- Loop through each domain in current_data and display it -->
          <span *ngIf="current_data?.domain?.length>0" class="type-chip bg-light-secondary domain-chip mr-1">
            Domains:<span  *ngFor="let item of current_data?.domain;let i = index" class="bg-light-primary badge badge-pill m-1">{{ item?.displayname }}</span>
          </span>
      </div>
      
      
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <table>
        <tr *ngIf="!modal_prop">
          <td class="title"><b><h4>{{current_data?.name}} <span *ngIf="user_role.roles=='admin' || empType.includes('Managment')"><i class="fa fa-edit cursor-pointer ml-3" (click)="editItem(current_data._id,current_data.name,'name')"></i> <span placement="top" ngbTooltip="copy url"><i class="ft-copy cursor-pointer ml-3" (click)="copyItem(current_data._id)"></i></span></span></h4></b>
            
            <span *ngFor="let item of current_data?.category">
              <span class="type-chip bg-light-primary badge badge-pill">{{item.name | titlecase}}</span>
            </span>
            
        </td>
        <div *ngIf="isUpdateName">
          <input type="text" class="form-control" [(ngModel)]="updated_data" [ngModelOptions]="{ standalone: true }" >
          <button class="btn btn-primary mt-1" (click)="update('name')">Update</button>
        </div>
        </tr>
        <!-- <tr>
          <td class="heading"><b>Type</b> <br>
            <span class="ml-3">{{current_data?.type}}</span>
          </td>
        </tr> -->
        <tr *ngIf="!modal_prop">
          <td class="d-flex justify-content-between">
            <span class="ml-3" [innerHTML]="current_data?.notes"></span> 
            <span *ngIf="user_role.roles=='admin' || empType.includes('Managment')"  class="ml-2"><i class="fa fa-edit cursor-pointer"  (click)="editItem(current_data._id,current_data.notes,'notes')"></i></span>
          </td>
        </tr>
        <div *ngIf="isUpdateNotes">
          <quill-editor (onEditorCreated)="setFocus($event)" (onContentChanged)="notes($event)" [(ngModel)]="updated_data"
            [ngModelOptions]="{ standalone: true }">
          </quill-editor>
          <button class="btn btn-primary mt-1" (click)="update('notes')">Update</button>
        </div>
       
        <tr *ngIf="modal_prop == 'skill' || !modal_prop">
          <td *ngIf="!isUpdateSkills"  class="heading"><b>Skill Keywords :</b> <span class="keyword-buttons">
               <span *ngIf="user_role.roles=='admin' || empType.includes('Managment')"   class="mx-2 my-1"><i class="fa fa-edit cursor-pointer" (click)="editItem(current_data._id,current_data.skill_keywords,'skill')"></i></span> <br>
            <span   class="collapse-content mt-3 ml-3">
              <span *ngFor="let skill of current_data?.skill_keywords; last as isLast">
                <span class="bg-light-info badge badge-pill mr-1 mb-1">{{skill?.name}}</span>
              </span>
            </span>
          </span></td>

          <div *ngIf="isUpdateSkills">
            <label>Skill Keywords</label>
            <div class="chip-container">
              <span class="chip" *ngFor="let keyword of skill_keywords; let i = index">
                {{ keyword?.name }}
                <button class="close-btn" (click)="removeKeyword(i, 'skill')">x</button>
              </span>
              <div class="input-group">
                <input #skillInput type="text"  (keydown.enter)="$event.preventDefault()" class="skill form-control border-0" placeholder="Add a skill keyword" />
                <button  class="btn  m-1" (click)="isUpdateSkills=!isUpdateSkills">Cancel</button>
                <button  class="btn btn-primary m-1" (click)="addKeyword(skillInput.value, 'skill'); skillInput.value=''">Update</button>
              </div>
            </div>
          </div>
        </tr>
        
        <tr *ngIf="modal_prop == 'feature' || !modal_prop">
          <td *ngIf="!isUpdateFeatures" class="heading"><b>Features Keywords :</b> <span class="keyword-buttons">
              <span *ngIf="user_role.roles=='admin' || empType.includes('Managment')" class="mx-2 my-1"><i class="fa fa-edit cursor-pointer"
                  (click)="editItem(current_data._id,current_data.features_keywords,'feature')"></i>
              </span> <br>
            <span class="collapse-content mt-3  ml-3">
              <span *ngFor="let feature of current_data?.features_keywords; last as isLast">
                <span class="bg-light-warning badge badge-pill mr-1 mb-1">{{feature?.name}}</span>
              </span>
            </span>
          </span></td>
          
          <div *ngIf="isUpdateFeatures">
            <label>Feature Keywords</label>
            <div class="chip-container">
              <span class="chip" *ngFor="let keyword of features_keywords; let i = index">
                {{ keyword?.name }}
                <button class="close-btn" (click)="removeKeyword(i, 'feature')">x</button>
              </span>
              <div class="input-group">
                <input #featureInput type="text"  (keydown.enter)="$event.preventDefault()" class="features form-control border-0" placeholder="Add a feature keyword" />
                <button  class="btn  m-1" (click)="isUpdateFeatures=!isUpdateFeatures">Cancel</button>
                <button class="btn btn-primary m-1" (click)="addKeyword(featureInput.value, 'feature'); featureInput.value=''">Update</button>
              </div>
            </div>
          </div>
          
        </tr>
        <tr *ngIf="modal_prop == 'project' || !modal_prop">
          <td *ngIf="!isUpdateProjects" class="heading"><b>Projects Keywords :</b> <span class="keyword-buttons">
              <span *ngIf="user_role.roles=='admin' || empType.includes('Managment')" class="mx-2 my-1"><i class="fa fa-edit cursor-pointer"
                  (click)="editItem(current_data._id,current_data.projects_keywords,'project')"></i>
              </span> <br>
            <span class="collapse-content mt-3  ml-3">
              <span *ngFor="let project of current_data?.projects_keywords; last as isLast">
                <span class="bg-light-secondary badge badge-pill mr-1 mb-1">{{project?.name}}</span>
              </span>
            </span>
          </span></td>
          <div *ngIf="isUpdateProjects">
            <label>Project Keywords</label>
            <div class="chip-container">
              <span class="chip" *ngFor="let keyword of projects_keywords; let i = index">
                {{ keyword?.name }}
                <button class="close-btn" (click)="removeKeyword(i,'project')">x</button>
              </span>
              <div class="input-group">
                <input #projectInput type="text"  (keydown.enter)="$event.preventDefault()" class="projects form-control border-0" placeholder="Add a Project keyword"/>
                <button  class="btn  m-1" (click)="isUpdateProjects=!isUpdateProjects">Cancel</button>
                <button  class="btn btn-primary m-1" (click)="addKeyword(projectInput.value, 'project'); projectInput.value=''">Update</button>
              </div>
            </div>
          </div>
        </tr>     
      </table>
    </div>

  </ng-template>

</div>


<!------------- Notes And Admin Notes Popup ------------------------>
<div>
  <ng-template #myModalNotesAdminNotes>
    <div class="modal-header">
      <h4 class="modal-title">{{current_row?.name}}'s Notes & Admin Notes</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <h5>Notes :</h5>
        <p [innerHTML]="current_row?.notes"></p>
      </div>
      <div class="form-group">
        <h5>Admin Notes :</h5>
        <p [innerHTML]="current_row?.admin_notes"></p>
      </div>
    </div>
   
  </ng-template>
</div>